<template>
  <div class="post-grid-item" @mouseenter="toggleDetail(true)" @mouseleave="toggleDetail(false)">
    <div class="grid-item-background">
      <div class="grid-item" :style="imageStyle">
        <div class="grid-blur" v-if="isShowDetail"></div>
        <div class="grid-detail">
          <div v-if="isShowDetail">
            <img class="icon" src="@/client/assets/images/icon_mention.svg" v-if="post.postType === 'mention'" /><img
              class="icon"
              src="@/client/assets/images/icon_retweet.svg"
              v-if="post.postType === 'retweet'"
            /><img
              class="icon"
              src="@/client/assets/images/icon_quote_tweet.svg"
              v-if="post.postType === 'quote_tweet'"
            /><span class="grid-date">{{ formatDatetime(post.publishDatetime) }}</span>
            <div class="grid-message" v-html="tweetText(post.message)"></div>
            <el-popover placement="top" trigger="click" v-model="isShowPopover" @hide="hidePopover">
              <post-detail
                :post="post"
                :snsType="snsType"
                :campaignType="campaignType"
                @change_is_widget="changeIsWidget"
                @change_is_candidate="changeIsCandidate"
                @change_is_winner="changeIsWinner"
                @change_ng="changeNg"
              ></post-detail>
              <el-button class="el-button--icon grid-button" type="default" slot="reference"
                ><i class="mdi mdi-dots-horizontal"></i
              ></el-button>
            </el-popover>
          </div>
          <post-name :post="post" :isWhite="true" :snsType="snsType"></post-name>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.post-grid-item {
  display: inline-block;
  width: 20%;
  padding: $spacing-unit;

  .grid-item-background {
    background-image: url('@/client/assets/images/no-photo.png');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
  }

  .grid-item {
    position: relative;
    min-height: 27 * $spacing-unit;
    overflow: hidden;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    border: 1px solid $border-color;
  }

  .grid-message {
    height: 120px;
    overflow-y: auto;
  }

  .grid-date {
    color: #ccc;
  }

  .post-name {
    position: absolute;
    bottom: 0;
    z-index: 1;
    padding: $spacing-unit 0;
  }

  .grid-detail {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    padding: $spacing-unit;
    color: $text-color-white;
    overflow-wrap: break-word;

    .icon {
      width: 12px;
      height: 12px;
      margin-right: $spacing-unit;
    }
  }

  .grid-button {
    position: absolute;
    right: $spacing-unit;
    bottom: $spacing-unit;
    z-index: 2;
  }

  .grid-blur {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.75;
  }
}
</style>
<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { defineComponent } from 'vue'

import Icon from '@/client/components/_atoms/basic_icon'
import PostDetail from '@/client/components/_atoms/post_detail'
import PostName from '@/client/components/_atoms/post_name'
import { formatDatetime, formatTweetText } from '@/client/filters/filters'

export default defineComponent({
  components: {
    Icon,
    PostName,
    PostDetail
  },
  props: {
    snsType: 'instagram' | 'twitter' | 'tiktok',
    post: Object,
    campaignType: String
  },
  data() {
    return {
      isShowDetail: false,
      isShowPopover: false
    }
  },
  computed: {
    imageStyle() {
      return { backgroundImage: `url(${this.post.mediaUrl || require('@/client/assets/images/no-photo.png')})` }
    }
  },
  methods: {
    formatDatetime,

    /**
     * セットショーの詳細
     */
    toggleDetail(state: boolean) {
      if (this.isShowPopover) {
        this.isShowDetail = this.isShowPopover
        return
      }

      this.isShowDetail = state
    },

    /**
     * ポップオーバーが近いとき
     */
    hidePopover() {
      this.isShowDetail = false
    },

    /**
     * ポストテキストをフォーマット
     */
    tweetText(text: string): string {
      return formatTweetText(text)
    },

    /**
     * ウィジェットフラグを変更
     */
    changeIsWidget() {
      this.$emit('change_is_widget', {
        postId: this.post.id,
        isWidget: this.post.isWidget
      })
    },

    /**
     * 候補者フラグを変更
     */
    changeIsCandidate() {
      this.$emit('change_is_candidate', {
        applicantId: this.post.applicantId,
        isCandidate: this.post.isCandidate
      })
    },

    /**
     * 当選者フラグを変更
     */
    changeIsWinner() {
      this.$emit('change_is_winner', {
        prizeId: this.post.prizeId,
        applicantId: this.post.applicantId,
        isWinner: this.post.isWinner
      })
    },

    /**
     * NGアカウントフラグを変更（伝播）
     */
    changeNg(payload: { screenName: string; isNg: boolean; ngApplicantId: number | null }) {
      this.$emit('change_ng', payload)
    }
  }
})
</script>
